import Mock from './Mock';

export default class AccountServiceMock {
  static forgotPassword() {
    return Mock.call({});
  }

  static resetPassword() {
    return Mock.call({});
  }

  static isLoggedIn() {
    return Mock.call();
  }

  static passwordExpiration() {
    return Mock.call();
  }
}
